import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/cooling_assist_setting.png'
import _imports_1 from '@/assets/images/icon_edit.png'
import _imports_2 from '@/assets/images/plus-icon-black.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-cb80a876")

_pushScopeId("data-v-cb80a876")
const _hoisted_1 = { class: "fridgecoolingassist-page" }
const _hoisted_2 = { class: "fridgecoolingassist-page-top" }
const _hoisted_3 = {
  class: "fridgecoolingassist-page-contents",
  ref: "scroll"
}
const _hoisted_4 = { class: "fridgecoolingassist-page-contents-contents" }
const _hoisted_5 = { class: "fridgecoolingassist-page-contents-contents-page" }
const _hoisted_6 = { class: "fridgecoolingassist-page-contents-contents-page-setting" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "fridgecoolingassist-page-contents-contents-page-setting-image" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "fridgecoolingassist-page-contents-contents-page-setting-image-image",
    src: _imports_0
  })
], -1)
const _hoisted_8 = { class: "fridgecoolingassist-page-contents-contents-page-setting-title" }
const _hoisted_9 = { class: "fridgecoolingassist-page-contents-contents-page-setting-title-text" }
const _hoisted_10 = { class: "fridgecoolingassist-page-contents-contents-page-setting-description" }
const _hoisted_11 = { class: "fridgecoolingassist-page-contents-contents-page-setting-description-text" }
const _hoisted_12 = { class: "fridgecoolingassist-page-contents-contents-page-setting-bottom" }
const _hoisted_13 = { class: "fridgecoolingassist-page-contents-contents-page-setting-bottom-button-text" }
const _hoisted_14 = { class: "fridgecoolingassist-page-contents-contents-myassist" }
const _hoisted_15 = {
  key: 0,
  class: "fridgecoolingassist-page-contents-contents-myassist-edit"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "fridgecoolingassist-page-contents-contents-myassist-edit-button-image",
  src: _imports_1
}, null, -1)
const _hoisted_17 = { class: "fridgecoolingassist-page-contents-contents-myassist-bottom" }
const _hoisted_18 = { class: "fridgecoolingassist-page-contents-contents-myassist-bottom-registstate" }
const _hoisted_19 = { class: "fridgecoolingassist-page-contents-contents-myassist-bottom-registstate-text" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  class: "fridgecoolingassist-page-contents-contents-myassist-bottom-button-image",
  src: _imports_2
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "fridgecoolingassist-page-contents-contents-page" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsTab = _resolveComponent("FridgeDetailsTab")
  const _component_FridgeDetailsMyAssistList = _resolveComponent("FridgeDetailsMyAssistList")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")
  const _component_FridgeDetailsConfirmCoolingAssistSettingDialog = _resolveComponent("FridgeDetailsConfirmCoolingAssistSettingDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_FridgeDetailsTab, {
        titleList: _ctx.tabTitleList,
        initialSelectedIndex: _ctx.initialTabIndex,
        onChangeTab: _ctx.changeTab
      }, null, 8, ["titleList", "initialSelectedIndex", "onChangeTab"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.coolingAssisTitleText), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.settingDescriptionText), 1)
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", {
                class: "fridgecoolingassist-page-contents-contents-page-setting-bottom-button",
                style: _ctx.styleSettingButton,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.settingButtonAction(...args)))
              }, [
                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.settingButtonTitleText), 1)
              ], 4)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("div", {
            class: "fridgecoolingassist-page-contents-contents-myassist-contents",
            style: _ctx.styleMyAssistContents
          }, [
            _createVNode(_component_FridgeDetailsMyAssistList, {
              key: _ctx.updateDisplayKey,
              myAssistList: _ctx.myAssistList,
              isEditMode: _ctx.isEditMode,
              onClickItem: _ctx.clickMyAssistItem,
              onClickDeleteItem: _ctx.clickDeleteMyAssistItem
            }, null, 8, ["myAssistList", "isEditMode", "onClickItem", "onClickDeleteItem"])
          ], 4),
          (_ctx.isEditAvailable)
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _createVNode("div", {
                  class: "fridgecoolingassist-page-contents-contents-myassist-edit-button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.myAssistEditButtonAction(...args)))
                }, [
                  _hoisted_16
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _createVNode("span", _hoisted_19, _toDisplayString(_ctx.myAssistRegistStateText), 1)
            ]),
            (_ctx.isDisplayAppendButton)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "fridgecoolingassist-page-contents-contents-myassist-bottom-button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.myAssistAppendButtonAction(...args)))
                }, [
                  _hoisted_20
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_21
      ])
    ], 512),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDialog,
      dialogType: _ctx.dialogType,
      title: _ctx.dialogTitle,
      message: _ctx.dialogMessage,
      positiveLabel: _ctx.dialogPositiveButtonLabel,
      negativeLabel: _ctx.dialogNegativeButtonLabel,
      onPositiveClick: _ctx.dialogPositiveHandler,
      onNegativeClick: _ctx.dialogNegativeHandler,
      onCloseClick: _ctx.dialogCloseHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick", "onCloseClick"]),
    _createVNode(_component_FridgeDetailsConfirmCoolingAssistSettingDialog, {
      isShowDialog: _ctx.isShowConfirmDialog,
      listName: _ctx.settingsListName,
      modeName: _ctx.settingModeName,
      minutes: _ctx.settingMinutes,
      seconds: _ctx.settingSeconds,
      isValidSeconds: _ctx.isValidSeconds,
      onClickCancel: _ctx.confirmCancel,
      onClickSend: _ctx.confirmSend
    }, null, 8, ["isShowDialog", "listName", "modeName", "minutes", "seconds", "isValidSeconds", "onClickCancel", "onClickSend"])
  ]))
})